import {  useState } from "react";
import { useNavigate } from "react-router-dom";
import { insuranceListType, searchParamsType } from "./types";
import { base, clinicId } from "../../../constants";
import { useQuery } from "react-query";
import { insuranceList } from "./service";
import moduleRoutes from "../../../routes/moduleRouteList";
import mastersRouteList from "../../routeList";
import insuanceMatserRouteList from "../routeList";
import { CheckBox, CheckBoxOutlineBlank, NoteAdd } from "@mui/icons-material";
import { Paper, Typography, Divider, TableContainer, Table, TableHead, TableRow, TableCell, IconButton, TablePagination, TextField } from "@mui/material";
import CustomTableBody from "../../../utilis/component/CustomTableBody";

function InsuranceDiscount() {
  
    const pageTitle = "Insurance Discount Master"
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useState<searchParamsType>({
        pageNumber: 0,
        pageSize: 25,
        searchText: "",
        status: 2,
        clinicId:clinicId
    });


    const {
        data: tableData,
        isLoading: tableDataLoading
    } = useQuery(
        ["", searchParams],
        async () => insuranceList(searchParams),
        {
            refetchOnWindowFocus: false,
        }
    );



    const handleChangePage = (
        _: React.MouseEvent<HTMLButtonElement> | null,
        pageNumber: number
    ) => {
        setSearchParams((prev) => ({
            ...prev,
            pageNumber,
        }));
    };

    const handleChangeRowsPerPage = (
        event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => {
        setSearchParams((prev) => ({
            ...prev,
            page: 0,
            pageSize: parseInt(event.target.value, 10),
        }));
    };

    const handleSearchText = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearchParams((prev) => ({
            ...prev,
            searchText: event.target.value,
            pageNumber: 0,
        }));
    };

    const handleNavigateClick = (data?: insuranceListType) => {
        navigate(
            `${base}${moduleRoutes.mainRoute}/${moduleRoutes.masters}/${mastersRouteList.insuranceMaster}/${insuanceMatserRouteList.insuranceDiscount}/${insuanceMatserRouteList.addOrEdit}`,
            { state: { data: data || null } }
        );
    };
    return (
        <div className="p-3">
            <Paper>
                <div className="flex justify-between p-3">
                    <div className="flex gap-2">
                        <Typography variant="h6" color={"default"}>
                            {pageTitle} 
                        </Typography>
                    </div>
                </div>
                <Divider />
                <div className="">
                      <div className="grid grid-cols-4 gap-3 py-3 px-2">
                                            
                                            <TextField label={"Search"} onChange={handleSearchText} />
                                        </div>
                    <TableContainer className="border">
                        <Table stickyHeader size="small">
                            <TableHead>
                                <TableRow>
                                    {headings.map((heading) => (
                                        <TableCell key={heading} className="font-bold">
                                            {heading}
                                        </TableCell>
                                    ))}
                                    <TableCell className="font-bold">Actions</TableCell>
                                </TableRow>
                            </TableHead>
                            <CustomTableBody
                                alert={"No data"}
                                dataLoading={tableDataLoading}
                                isData={Boolean(tableData?.response?.items?.length)}
                                totalSpan={{
                                    row: searchParams.pageSize,
                                    col: headings.length + 2,
                                }}
                            >
                                {tableData?.response?.items?.map((tableItem, index) => (
                                    <TableRow key={`${pageTitle}-${index}`}>
                                        <TableCell>{tableItem?.insuranceName}</TableCell>
                                        <TableCell>{tableItem?.discountAdded?<CheckBox color="primary"/>:<CheckBoxOutlineBlank color="primary"/>}  </TableCell>
                                        <TableCell>
                                            <div className="flex gap-2">

                                                <IconButton
                                                    color="primary"
                                                    onClick={() => {
                                                        handleNavigateClick(tableItem);
                                                    }}
                                                >
                                                    <NoteAdd />
                                                </IconButton>
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </CustomTableBody>
                        </Table>
                        <div className="flex justify-end">
                            <TablePagination
                                rowsPerPageOptions={[5, 10, 25]}
                                component={"div"}
                                count={tableData?.response?.totalRecords || 0}
                                rowsPerPage={searchParams.pageSize}
                                page={searchParams.pageNumber}
                                sx={{ border: 0 }}
                                slotProps={{
                                    select: {
                                        inputProps: {
                                            "aria-label": "rows per page",
                                        },
                                        native: true,
                                    },
                                }}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                            />
                        </div>
                    </TableContainer>
                </div>
            </Paper>
        </div>
    );


}

export default InsuranceDiscount

const headings = [
    "Insurance Name",
    "Discount Added"
];
